import React, {useState} from "react";
import useEditableTableDateCell from "../../../hooks/useEditableTableDateCell";
import useEditableTableCostCell from "../../../hooks/useEditableTableCostCell";
import useEditableTableTextAreaCell from "../../../hooks/useEditableTableTextAreaCell";
import NominalCodePicker from "../../Settings/NominalCodes/NominalCodePicker";
import TrackingOptionsPicker from "../../Settings/TrackingCategory/TrackingOptionsPicker";


export default function ApprovalModalRow({invoice, onChange, onSave, Objkey, onNominalChange, nominalCodes, onTrackingChange, trackingOptions}){
    const [editable, setEditable] = useState(false);

    const handleSave = (data) => {
        onSave(data);
        setEditable(false);
    }

    return (
        <tr>
            <td>{invoice.id}</td>
            {useEditableTableDateCell({
                propName: "invoice_date",
                value: invoice.invoice_date,
                onChange: e => onChange(e, Objkey),
                onSave: () => handleSave(invoice),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            <td>
                <NominalCodePicker
                    options={nominalCodes}
                    onSave={() => handleSave(invoice)}
                    onChange={e => onNominalChange(e, Objkey)}
                    name={"vat_nominal_code"}
                    inlineEdit={true}
                    disabled={!editable}
                    setEditable={setEditable}
                    editable={editable}
                    value={invoice.vat_nominal_code}
                    blank={true}
                    small={false}
                />
            </td>
            <td>
                <NominalCodePicker
                    options={nominalCodes}
                    onSave={() => handleSave(invoice)}
                    onChange={e => onNominalChange(e, Objkey)}
                    name={"no_vat_nominal_code"}
                    inlineEdit={true}
                    disabled={!editable}
                    setEditable={setEditable}
                    editable={editable}
                    value={invoice.no_vat_nominal_code}
                    blank={true}
                    small={false}
                />
            </td>
            {useEditableTableCostCell({
                propName: "amount",
                value: invoice.amount,
                onChange: e => onChange(e, Objkey),
                onSave: () => handleSave(invoice),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            {useEditableTableCostCell({
                propName: "no_vat_amount",
                value: invoice.no_vat_amount,
                onChange: e => onChange(e, Objkey),
                onSave: () => handleSave(invoice),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
            <td>
                <TrackingOptionsPicker
                    options={trackingOptions}
                    onSave={() => handleSave(invoice)}
                    onChange={e => onTrackingChange(e, Objkey)}
                    name={"tracking_option"}
                    inlineEdit={true}
                    disabled={!editable}
                    setEditable={setEditable}
                    editable={editable}
                    value={invoice.tracking_option}
                    blank={true}
                    className={""}
                />
            </td>
            {useEditableTableTextAreaCell({
                propName: "description",
                value: invoice.description,
                onChange: e => onChange(e, Objkey),
                onSave: () => handleSave(invoice),
                editable,
                setEditable,
                disabled: false,
                inlineEdit: true
            })}
        </tr>
    )

}